import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/Landing.vue'),
    meta: { public: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/api-doc',
    name: 'PublicApiDoc',
    component: () => import('@/views/ApiDoc.vue'),
    meta: { public: true, standaloneDoc: true, title: 'API文档' }
  },
  {
    path: '/console',
    component: AppLayout,
    redirect: '/console/dashboard',
    meta: { role: 'merchant' },
    children: [
      {
        path: 'dashboard',
        name: 'MerchantDashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '账户总览', role: 'merchant' }
      },
      {
        path: 'orders',
        name: 'MerchantOrders',
        component: () => import('@/views/Orders.vue'),
        meta: { title: '充值管理', role: 'merchant' }
      },
      {
        path: 'withdraw',
        name: 'MerchantWithdraw',
        component: () => import('@/views/Withdraw.vue'),
        meta: { title: '结算管理', role: 'merchant' }
      },
      {
        path: 'user-withdraw',
        name: 'MerchantUserWithdraw',
        component: () => import('@/views/UserWithdraw.vue'),
        meta: { title: '付款管理', role: 'merchant' }
      },
      {
        path: 'api',
        name: 'MerchantApi',
        component: () => import('@/views/ApiManage.vue'),
        meta: { title: 'API管理', role: 'merchant' }
      },
      {
        path: 'api-doc',
        name: 'ApiDoc',
        component: () => import('@/views/ApiDoc.vue'),
        meta: { title: 'API文档', role: 'merchant' }
      }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((r) => r.meta.public)
  if (isPublic) {
    next()
    return
  }
  const token = sessionStorage.getItem('cryptopay_token')
  if (!token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
